import React from 'react';

interface DragRectangleProps {
  startX: number;
  startY: number;
  endX: number;
  endY: number;
  color: string;
  isVisible: boolean;
}

const DragRectangle: React.FC<DragRectangleProps> = ({
  startX,
  startY,
  endX,
  endY,
  color,
  isVisible,
}) => {
  if (!isVisible) {
    return null;
  }

  // Calculate rectangle dimensions and position
  const left = Math.min(startX, endX);
  const top = Math.min(startY, endY);
  const width = Math.abs(endX - startX);
  const height = Math.abs(endY - startY);

  // Don't render if the rectangle is too small
  if (width < 2 || height < 2) {
    return null;
  }

  return (
    <div
      style={{
        position: 'absolute',
        left: `${left}px`,
        top: `${top}px`,
        width: `${width}px`,
        height: `${height}px`,
        backgroundColor: color,
        opacity: 0.3,
        border: `2px solid ${color}`,
        borderRadius: '4px',
        pointerEvents: 'none',
        zIndex: 1000,
        boxShadow: `0 0 8px ${color}40`,
        transition: 'all 0.1s ease-out',
      }}
    />
  );
};

export default DragRectangle;
